import * as Yup from 'yup';

export const buildErrorNotifSchema = () =>
  Yup.object({
    email: Yup.string()
      .email('Must be a valid email')
      .matches(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/, {
        message: 'Must be a valid email',
        excludeEmptyString: true,
      })
      .required('Email is required'),
  });
